import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../ui/Navbar'
import Footer from '../ui/Footer'
import FloatingWhatsApp from '../common/FloatingWhatsApp'

function AppLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <FloatingWhatsApp />
      <Footer />
    </div>
  )
}

export default AppLayout
